import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=7ef39993&scoped=true&"
import script from "./CrudTable.vue?vue&type=script&lang=js&"
export * from "./CrudTable.vue?vue&type=script&lang=js&"
import style0 from "./CrudTable.vue?vue&type=style&index=0&id=7ef39993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef39993",
  null
  
)

export default component.exports